module.exports = __webpack_public_path__ + "static/media/bg-login.e2f3435c.svg";